import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";

const Pending2 = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const [overallList, setOverallList] = useState();

  const dashboardList = async (val) => {
    let res = await post(URLS.DASHBOARD_LIST);
    if (res?.status == "success") {
      if (res?.overall_ticket) {
        setOverallList(res?.overall_ticket);
      }
    }
  };

  useEffect(() => {
    dashboardList();
  }, []);

  const role = localStorage.getItem("role");
  console.log("overallList?.inventory_group", overallList?.inventory_group);

  const stats = [
    {
      label: "Yet to Start - ",
      value: overallList?.inventory_group?.yet_to_start ?? "0",
      path: "/table-inventory",
    },
    {
      label: "Dispatch - ",
      value: overallList?.inventory_group?.dispatched ?? "0",
      path: "/dispatch-table",
    },
    {
      label: "Delivered - ",
      value: overallList?.inventory_group?.delivered ?? "0",
      path: "/delivery-table",
    },
    {
      label: "Technical Support - ",
      value: overallList?.inventory_group?.assigned_to_technical ?? "0",
      path: "/table-technical",
    },
  ];

  const technicalStats = [
    {
      label: "Yet to Start - ",
      value: overallList?.technical_group?.yet_to_start ?? "0",
      path: "/table-inventory",
    },
    {
      label: "Issue Resolved - ",
      value: overallList?.technical_group?.issue_resolved ?? "0",
      path: "/dispatch-table",
    },
    {
      label: "Super Admin - ",
      value: overallList?.technical_group?.moved_to_super_admin ?? "0",
      path: "/delivery-table",
    },
    {
      label: "Inventory Support - ",
      value: overallList?.technical_group?.assigned_to_inventory ?? "0",
      path: "/table-technical",
    },
  ];

  const handleClick = (index, path) => {
    setActiveIndex(index);
    navigate(path);
  };

  return (
    <div>
      <Topbar header="Pending" subHead="Move" />
      <div className="container_fluit1 px-4 py-3">
        {role == "Inventory" ? (
          <div className="d-flex flex-wrap gap-3 ac-js">
            {stats.map((item, index) => (
              <div
                key={index}
                className={`box_Value d-flex ac-jc ${
                  activeIndex === index ? "box_Value_active" : ""
                }`}
                onClick={() => handleClick(index, item.path)}
                style={{ cursor: "pointer" }}
              >
                <button
                  className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: activeIndex === index ? "white" : "black",
                  }}
                >
                  {item.label}
                  {item.value}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="d-flex flex-wrap gap-3 ac-js">
            {console.log("item===>", technicalStats)}
            {technicalStats.map((item, index) => (
              <div
                key={index}
                className={`box_Value d-flex ac-jc ${
                  activeIndex === index ? "box_Value_active" : ""
                }`}
                onClick={() => handleClick(index, item.path)}
                style={{ cursor: "pointer" }}
              >
                <button
                  className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                  style={{
                    border: "none",
                    background: "transparent",
                    color: activeIndex === index ? "white" : "black",
                  }}
                >
                  {item.label}
                  {item.value}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Pending2;
